export const APPLICATION_COMPARISON_SET_COMPARED_DATA_LOADING = '@application-comparison/set-compared-data-loading';
export const APPLICATION_COMPARISON_SET_COMPARED_DATA = '@application-comparison/set-compared-data';
export const APPLICATION_COMPARISON_RESET_COMPARED_DATA = '@application-comparison/reset-compared-data';

export const APPLICATION_COMPARISON_GET_COMPARED_DATA = '@application-comparison/get-compared-data';


// WEBPACK FOOTER //
// ./src/actions/applications/comparison/types.js